import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import DialogContent from "@material-ui/core/DialogContent";
import { Box, Grid, Switch, Typography } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { userActions } from "../../../_redux/actions";
import { useDispatch, useSelector } from "react-redux";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { utilFunctions } from "../../../_helpers";
import { alertActions } from "../../../_redux/actions";
import FormControlWrapper from "../../_shared/FormControlWrapper";
import { IEDistributionAddUpdatePopupStructure } from "../../../_models"
import ShiftSelect from "../../_shared/ShiftSelect";

const IEDistributionAddUpdate = (props) => {

    return (
        <React.Fragment>
            <DialogContent>
                <Typography className="uppercase fontSizePrimary">Please fill the detail below to add a new ie distribution to the factory.</Typography>
                {/* <Typography className="uppercase fontSizePrimary mtM">
                    <Box color="error.main" fontSize={14}>{createUser.isError ? createUser.error.message : null}</Box>
                </Typography> */}
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Shift" variant="block" isRequired={props.ieDistributionAddUpdatePopupData.shift.isRequired}>
                            <ShiftSelect
                                error={!!props.ieDistributionAddUpdatePopupData.shift.error}
                                shifts={props.shifts}
                                disabled={props.ieDistributionAddUpdatePopupData.shift.disabled}
                                onShiftChange={(value) => props.onAddUpdatePopupChange('shift', value)}
                                selectedValue={props.ieDistributionAddUpdatePopupData.shift.value} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="VSM Code" variant="block" isRequired={props.ieDistributionAddUpdatePopupData.vsmCode.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => props.onAddUpdatePopupChange('vsmCode', event.target.value)}
                                value={props.ieDistributionAddUpdatePopupData.vsmCode.value}
                                error={!!props.ieDistributionAddUpdatePopupData.vsmCode.error}
                                disabled={props.ieDistributionAddUpdatePopupData.vsmCode.disabled}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Module" variant="block" isRequired={props.ieDistributionAddUpdatePopupData.module.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => props.onAddUpdatePopupChange('module', event.target.value)}
                                value={props.ieDistributionAddUpdatePopupData.module.value}
                                error={!!props.ieDistributionAddUpdatePopupData.module.error}
                                disabled={props.ieDistributionAddUpdatePopupData.module.disabled}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="IE Name" variant="block" isRequired={props.ieDistributionAddUpdatePopupData.ieName.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => props.onAddUpdatePopupChange('ieName', event.target.value)}
                                value={props.ieDistributionAddUpdatePopupData.ieName.value}
                                error={!!props.ieDistributionAddUpdatePopupData.ieName.error}
                                disabled={props.ieDistributionAddUpdatePopupData.ieName.disabled}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControlWrapper label="Email" variant="block" isRequired={props.ieDistributionAddUpdatePopupData.emailAddress.isRequired}>
                            <TextField
                                id="outlined-textarea"
                                onChange={(event) => props.onAddUpdatePopupChange('emailAddress', event.target.value)}
                                value={props.ieDistributionAddUpdatePopupData.emailAddress.value}
                                error={!!props.ieDistributionAddUpdatePopupData.emailAddress.error}
                                disabled={props.ieDistributionAddUpdatePopupData.emailAddress.disabled}
                                size="small"
                                variant="outlined"
                            />
                        </FormControlWrapper>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={props.onAddUpdatePopupClear}>
                    Clear
                </Button>
                <Button variant="contained" color="secondary" onClick={props.onAddIEDistribution}>
                    Save
                </Button>
            </DialogActions>
        </React.Fragment>
    )

}

IEDistributionAddUpdate.propTypes = {
    shifts: PropTypes.array,
    ieDistributionAddUpdatePopupData: PropTypes.object,
    onAddIEDistribution: PropTypes.func,
    onAddUpdatePopupChange: PropTypes.func,
    onAddUpdatePopupClear: PropTypes.func
}

export default IEDistributionAddUpdate;
